import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { TextAreaProps } from './text-area.component';
import TextArea from './text-area.component';

export interface HfTextAreaProps extends TextAreaProps {
  control: Control<FieldValues>;
  name: string;
}

export default function HfTextArea({
  control,
  name,
  label,
  rows,
  value,
  readOnly,
  required,
  placeholder,
  onFocus,
  onChange,
  fieldValueConverter,
  labelStyles,
  maxLength,
  showCharacterCounter = false,
}: HfTextAreaProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      defaultValue={value}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextArea
          name={name}
          label={label}
          rows={rows}
          value={value}
          error={error?.message}
          readOnly={readOnly}
          required={required}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          labelStyles={labelStyles}
          maxLength={maxLength}
          showCharacterCounter={showCharacterCounter}
        />
      )}
    />
  );
}
